// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import DocumentMeta from 'react-document-meta'
import { Switch, Route } from 'react-router-dom'

// Internal Dependencies:
import MainLayout from 'layouts/MainLayout'
import Home from 'pages/Home'
import Register from 'pages/Register'
import Activate from 'pages/Activate'
import Profile from 'pages/Profile'
import Contacts from 'pages/Contacts'

// Redux:
import * as reduxSite from 'actions/site'
import * as reduxUser from 'actions/user'
import * as reduxTickets from 'actions/tickets'

class SiteContainer extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		window.addEventListener( 'resize', this.onResize )

		this.props.dispatch( reduxUser.getUserData() )
	}

	onResize = () => {
		this.props.dispatch( reduxSite.getScreenSize() )
	}

	render() {
		const meta = {
			title: siteData.site_name
		}

		return [
			<DocumentMeta { ...meta } key="DocumentMeta" />,

			<Switch key="Switch">
				<Route path="/" exact render={ props => (
					<MainLayout { ...props }>
						<Home { ...props } />
					</MainLayout>
				) } />

				<Route path="/activate" exact render={ props => (
					<MainLayout { ...props }>
						<Activate { ...props } />
					</MainLayout>
				) } />

				<Route path="/register" exact render={ props => (
					<MainLayout { ...props }>
						<Register { ...props } />
					</MainLayout>
				) } />

				<Route path="/new-claim" exact render={ props => (
					<MainLayout { ...props }>
						<Register { ...props } />
					</MainLayout>
				) } />

				<Route path="/profile" exact render={ props => (
					<MainLayout { ...props }>
						<Profile { ...props } />
					</MainLayout>
				) } />

				<Route path="/contacts" exact render={ props => (
					<MainLayout { ...props }>
						<Contacts { ...props } />
					</MainLayout>
				) } />
			</Switch>
		]
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( SiteContainer )
